<script>
import _get from 'lodash-es/get'

export default {
  name: 'TeacherNameOrYou',

  props: {
    teacher: {
      required: true
    }
  },

  computed: {
    isCurrent() {
      return _get(this.teacher, 'isCurrent', false)
    },

    first() {
      return _get(this.teacher, 'first')
    },

    last() {
      return _get(this.teacher, 'last')
    },

    thirdPerson() {
      if(this.last || this.first) {
        var firstLast = [this.first, this.last]
        return firstLast.join(' ')
      } else {
        return _get(this.teacher, 'email')
      }
    },

    display() {
      if (this.isCurrent) {
        return 'You'
      } else {
        return this.thirdPerson
      }
    }
  },

  render() {
    return this.$scopedSlots.default({
      display: this.display,
    })
  },

}
</script>
